(function () {
  'use strict';
  var S = window.SITRA || {};
  var U = S.u;
  var $ = U.$, $$ = U.$$, money = U.money, lockScroll = U.lockScroll, store = U.store, esc = U.esc, addToCart = U.addToCart, renderCart = U.renderCart, cartFetch = U.cartFetch, shipProgress = U.shipProgress, wishInit = U.wishInit;

  function setHeaderH() { var h = $('.hdr'); if (h) document.documentElement.style.setProperty('--hdr-h', h.offsetHeight + 'px'); }
  function initSlideshow(root) {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    var slides = $$('.hero__slide', root); if (slides.length < 2) return;
    var dots = $$('.hero__dot', root); var i = 0; var timer;
    function go(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    function play() { var ms = parseInt(root.dataset.autoplay || '0', 10); if (ms) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, ms); } }
    root.addEventListener('click', function (e) {
      if (e.target.closest('.hero__arrow--prev')) { go(i - 1); play(); }
      if (e.target.closest('.hero__arrow--next')) { go(i + 1); play(); }
      var d = e.target.closest('.hero__dot'); if (d) { go(dots.indexOf(d)); play(); }
    });
    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', play);
    play();
  }

  /* ---------- delivery estimate ---------- */
  var HOL = ['2026-11-11', '2026-11-26', '2026-12-25', '2027-01-01', '2027-01-18', '2027-02-15', '2027-05-31', '2027-06-18', '2027-07-05', '2027-09-06', '2027-10-11', '2027-11-11', '2027-11-25', '2027-12-24', '2027-12-31'];
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function addCal(d, n) { var x = new Date(d.getTime()); x.setDate(x.getDate() + n); return x; }
  function addBiz(d, n) { var x = new Date(d.getTime()), k = 0; while (k < n) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w && w !== 6 && HOL.indexOf(iso(x)) < 0) k++; } return x; }
  function fmt(d, long) { return d.toLocaleDateString('en-US', long ? { weekday: 'short', month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric' }); }
  function initDelivery(root) {
    var D = S.delivery || { pMin: 1, pMax: 3, tMin: 6, tMax: 10 };
    var now = new Date(); var sa = addCal(now, D.pMin), sb = addCal(now, D.pMax), da = addBiz(sa, D.tMin), db = addBiz(sb, D.tMax);
    $$('[data-dl]', root).forEach(function (el) {
      var k = el.dataset.dl;
      el.textContent = k === 'range' ? fmt(da, true) + ' – ' + fmt(db, true) : k === 'short' ? fmt(da) + '–' + fmt(db) : k === 'today' ? 'Today, ' + fmt(now) : k === 'ship' ? fmt(sa) + ' – ' + fmt(sb) : k === 'arrive' ? fmt(da) + ' – ' + fmt(db) : el.textContent;
    });
  }

  /* ---------- product page ---------- */
  function initProduct(root) {
    var jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var inv = JSON.parse(($('[data-inventory-json]', root) || { textContent: '{}' }).textContent);
    var form = $('form[data-product-form]', root);
    var idInput = $('input[name="id"]', form);
    var selected = [];
    var current = product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];
    var chosenByUser = $$('[data-option-index]', root).length === 0 || product.variants.length === 1 || !!root.dataset.preselected;
    selected = current.options.slice();
    var qtyInput = $('[data-qty]', root);
    var lowAt = parseInt(root.dataset.lowStock || '0', 10);

    function findVariant() { return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === selected[i]; }); }); }
    function update() {
      var v = findVariant(); current = v;
      $$('[data-option-index]', root).forEach(function (btn) {
        var i = parseInt(btn.dataset.optionIndex, 10);
        btn.classList.toggle('is-active', selected[i] === btn.dataset.value && (chosenByUser || btn.dataset.kind !== 'size'));
        var test = selected.slice(); test[i] = btn.dataset.value;
        var match = product.variants.find(function (x) { return x.options.every(function (o, k) { return o === test[k]; }); });
        btn.classList.toggle('is-unavailable', !match || !match.available);
      });
      $$('[data-selected-value]', root).forEach(function (el) { var i = parseInt(el.dataset.selectedValue, 10); el.textContent = (chosenByUser || el.dataset.kind !== 'size') ? selected[i] : 'Select'; });
      var btn = $('[data-atc]', root); var sticky = $('[data-sticky-atc]');
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value || '1', 10));
      var label;
      if (!v) { label = 'Unavailable'; } else if (!chosenByUser) { label = 'Select a size'; } else if (!v.available) { label = 'Sold out'; } else { label = 'Add to bag · ' + money(v.price * qty); }
      [btn, sticky].forEach(function (b) { if (b) { b.textContent = label; b.disabled = !!(v && !v.available && chosenByUser) || !v; } });
      if (!v) return;
      idInput.value = v.id;
      var p = $('[data-price]', root); if (p) p.textContent = money(v.price);
      var c = $('[data-compare]', root); if (c) { c.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; c.hidden = !(v.compare_at_price > v.price); }
      var pw = $('[data-price-wrap]', root); if (pw) pw.classList.toggle('price--sale', v.compare_at_price > v.price);
      var sp = $('[data-sticky-price]'); if (sp) sp.textContent = money(v.price);
      var sv = $('[data-sticky-variant]'); if (sv) sv.textContent = chosenByUser ? v.title : 'Select a size';
      var st = $('[data-stock]', root);
      if (st) {
        var info = inv[v.id] || {}; var cls = 'stock'; var txt;
        if (!v.available) { cls += ' stock--out'; txt = 'Sold out in this option'; }
        else if (info.m === 'shopify' && info.p !== 'continue' && info.q > 0 && lowAt && info.q <= lowAt && chosenByUser) { cls += ' stock--low'; txt = 'Only ' + info.q + ' left in ' + (selected[parseInt(root.dataset.sizeIndex || '0', 10)] || 'this size'); }
        else txt = 'In stock';
        st.className = cls; $('[data-stock-text]', st).textContent = txt;
      }
      if (v.featured_media) showMedia(v.featured_media.id);
      updateCost();
      if (chosenByUser && window.history.replaceState) { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); }
    }
    function updateCost() {
      var box = $('[data-cost]', root); if (!box || !current) return;
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value || '1', 10));
      var sub = current.price * qty; var th = S.freeShip || 0;
      $('[data-cost-qty]', box).textContent = qty;
      $('[data-cost-sub]', box).textContent = money(sub);
      var free = th && sub >= th;
      $('[data-cost-ship]', box).textContent = free ? 'Free' : (S.flatShip || 'Calculated at checkout');
      var flat = parseFloat(String(S.flatShip || '').replace(/[^0-9.]/g, ''));
      $('[data-cost-total]', box).textContent = free || isNaN(flat) ? money(sub) : money(sub + Math.round(flat * 100));
      var sp = shipProgress(sub);
      var msg = $('[data-cost-msg]', box), bar = $('.bar span', box);
      if (sp) { msg.textContent = sp.msg; bar.style.width = sp.pct + '%'; }
      $$('[data-ship-note]', root).forEach(function (el) { el.textContent = free ? 'free on this order' : (S.flatShip || '') + ', free over ' + money(th); });
    }
    function showMedia(id) {
      var imgs = $$('.gallery__main img', root); var thumbs = $$('.gallery__thumb', root);
      var idx = imgs.findIndex(function (im) { return im.dataset.mediaId === String(id); }); if (idx < 0) return;
      imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === idx); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === idx ? 'true' : 'false'); });
      var cnt = $('.gallery__count', root); if (cnt) cnt.textContent = (idx + 1) + ' / ' + imgs.length;
    }
    root.addEventListener('click', function (e) {
      var t = e.target.closest('.gallery__thumb'); if (t) { showMedia(t.dataset.mediaId); return; }
      var o = e.target.closest('[data-option-index]');
      if (o) { selected[parseInt(o.dataset.optionIndex, 10)] = o.dataset.value; if (o.dataset.kind === 'size') chosenByUser = true; var er = $('[data-form-error]', root); if (er) er.hidden = true; update(); return; }
      var qb = e.target.closest('[data-qty-step]');
      if (qb) { qtyInput.value = Math.max(1, parseInt(qtyInput.value || '1', 10) + parseInt(qb.dataset.qtyStep, 10)); update(); return; }
      if (e.target.closest('[data-size-chart-open]')) { var m = $('#SizeChart'); if (m) { m.classList.add('is-open'); lockScroll(true); } return; }
      if (e.target.closest('[data-bundle-add]')) {
        if (!chosenByUser) { var er2 = $('[data-form-error]', root); if (er2) er2.hidden = false; return; }
        var items = [{ id: current.id, quantity: 1 }];
        $$('[data-bundle-item]:checked', root).forEach(function (cb) { items.push({ id: parseInt(cb.value, 10), quantity: 1 }); });
        addToCart(items);
      }
    });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-modal-close]')) { $$('.modal.is-open').forEach(function (m) { m.classList.remove('is-open'); }); lockScroll(false); } });
    if (qtyInput) qtyInput.addEventListener('change', update);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!chosenByUser) { var er = $('[data-form-error]', root); if (er) er.hidden = false; return; }
      var fd = new FormData(form); var items = [{ id: parseInt(fd.get('id'), 10), quantity: parseInt(fd.get('quantity') || '1', 10) }];
      var b = $('[data-atc]', root); b.disabled = true;
      addToCart(items).finally(function () { b.disabled = false; });
    });
    var sticky = $('[data-sticky-atc]');
    if (sticky) sticky.addEventListener('click', function () { if (!chosenByUser) { window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 80, behavior: 'smooth' }); var er = $('[data-form-error]', root); if (er) er.hidden = false; return; } form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true })); });
    var bar = $('.sticky-atc'); var anchor = $('[data-atc]', root);
    if (bar && anchor && 'IntersectionObserver' in window) new IntersectionObserver(function (es) { bar.classList.toggle('is-visible', !es[0].isIntersecting && es[0].boundingClientRect.top < 0); }).observe(anchor);
    var rv = store('sitra-recent') || []; rv = rv.filter(function (h) { return h !== product.handle; }); rv.unshift(product.handle); store('sitra-recent', rv.slice(0, 12));
    update();
  }

  /* ---------- recently viewed ---------- */
  function initRecent(root) {
    var list = (store('sitra-recent') || []).filter(function (h) { return h !== root.dataset.exclude; }).slice(0, parseInt(root.dataset.limit || '6', 10));
    var grid = $('[data-recent-grid]', root); if (!list.length || !grid) return;
    Promise.all(list.map(function (h) { return fetch((S.routes.root || '/') + 'products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        ps = ps.filter(Boolean); if (!ps.length) return;
        grid.innerHTML = ps.map(function (p) {
          var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
          return '<a href="' + esc(p.url) + '" style="display:flex;flex-direction:column;gap:6px;text-decoration:none"><div style="aspect-ratio:3/4;background:var(--surface);overflow:hidden;border-radius:var(--radius)">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" loading="lazy" style="width:100%;height:100%;object-fit:cover">' : '') + '</div><span style="font-size:12px;line-height:1.3">' + esc(p.title) + '</span><span style="font-size:12px;font-weight:700">' + money(p.price) + '</span></a>';
        }).join('');
        root.hidden = false;
      });
  }

  /* ---------- countdown ---------- */
  function initCountdown(root) {
    var end = Date.parse(root.dataset.end); if (isNaN(end)) { root.hidden = true; return; }
    var pad = function (n) { return String(n).padStart(2, '0'); };
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { root.hidden = true; return; }
      var u = { d: Math.floor(left / 864e5), h: Math.floor(left / 36e5) % 24, m: Math.floor(left / 6e4) % 60, s: Math.floor(left / 1e3) % 60 };
      $$('[data-cd]', root).forEach(function (el) { el.textContent = pad(u[el.dataset.cd]); });
      setTimeout(tick, 1000);
    }
    root.hidden = false; tick();
  }

  /* ---------- recommendations ---------- */
  function initRecs(root) {
    fetch(root.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var d = document.createElement('div'); d.innerHTML = html;
      var inner = d.querySelector('[data-recs]');
      if (inner && inner.querySelector('.card')) { root.innerHTML = inner.innerHTML; root.hidden = false; wishInit(root); }
    }).catch(function () {});
  }

  /* ---------- boot ---------- */
  function boot() {
    setHeaderH();
    $$('[data-slideshow]').forEach(initSlideshow);
    $$('[data-product-section]').forEach(initProduct);
    $$('[data-delivery]').forEach(initDelivery);
    $$('[data-recent]').forEach(initRecent);
    $$('[data-countdown]').forEach(initCountdown);
    $$('[data-recs-url]').forEach(function (el) { el.dataset.url = el.dataset.recsUrl; initRecs(el); });
    wishInit(document);
    if (S.cartType === 'drawer') cartFetch().then(renderCart).catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();